export default __webpack_public_path__ + "static/media/l.bf82ddba.wav";